module.exports = [
	{
		"biomeName": "Alpine",
		"primaryColor": [
			184,
			219,
			242
		],
		"gradientTopColor": [
			123,
			146,
			161
		],
		"gradientBottomColor": [
			80,
			95,
			105
		]
	},
	{
		"biomeName": "Boreal Forest",
		"primaryColor": [
			9,
			64,
			45
		],
		"gradientTopColor": [
			9,
			64,
			45
		],
		"gradientBottomColor": [
			6,
			38,
			27
		]
	},
	{
		"biomeName": "Chaparral",
		"primaryColor": [
			173,
			83,
			74
		],
		"gradientTopColor": [
			143,
			59,
			51
		],
		"gradientBottomColor": [
			99,
			30,
			23
		]
	},
	{
		"biomeName": "Desert",
		"primaryColor": [
			243,
			240,
			154
		],
		"gradientTopColor": [
			191,
			172,
			76
		],
		"gradientBottomColor": [
			120,
			106,
			36
		]
	},
	{
		"biomeName": "Savanna",
		"primaryColor": [
			190,
			165,
			89
		],
		"gradientTopColor": [
			130,
			110,
			47
		],
		"gradientBottomColor": [
			82,
			68,
			29
		]
	},
	{
		"biomeName": "Temperate Deciduous Forest",
		"primaryColor": [
			45,
			104,
			18
		],
		"gradientTopColor": [
			39,
			105,
			11
		],
		"gradientBottomColor": [
			19,
			54,
			4
		]
	},
	{
		"biomeName": "Temperate Coniferous Forest",
		"primaryColor": [
			88,
			153,
			58
		],
		"gradientTopColor": [
			78,
			135,
			51
		],
		"gradientBottomColor": [
			38,
			74,
			23
		]
	},
	{
		"biomeName": "Temperate Grassland",
		"primaryColor": [
			173,
			170,
			74
		],
		"gradientTopColor": [
			138,
			135,
			51
		],
		"gradientBottomColor": [
			84,
			82,
			24
		]
	},
	{
		"biomeName": "Tropical Dry Forest",
		"primaryColor": [
			158,
			181,
			92
		],
		"gradientTopColor": [
			104,
			120,
			61
		],
		"gradientBottomColor": [
			62,
			71,
			37
		]
	},
	{
		"biomeName": "Tropical Rain Forest",
		"primaryColor": [
			45,
			181,
			58
		],
		"gradientTopColor": [
			31,
			163,
			43
		],
		"gradientBottomColor": [
			12,
			102,
			21
		]
	},
	{
		"biomeName": "Tundra",
		"primaryColor": [
			98,
			168,
			211
		],
		"gradientTopColor": [
			44,
			107,
			150
		],
		"gradientBottomColor": [
			26,
			71,
			99
		]
	},
	{
		"biomeName": "Polar Ice",
		"primaryColor": [
			236,
			242,
			246
		],
		"gradientTopColor": [
			149,
			154,
			156
		],
		"gradientBottomColor": [
			100,
			103,
			105
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/resources/data/biome-db-info.json
// module id = 675
// module chunks = 0